import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Dashboard from "@/pages/Dashboard";
import LeadDetailPage from "@/pages/LeadDetailPage";
import LeadsListPage from "@/pages/LeadsListPage";
import Reports from "@/pages/Reports";
import SettingsPage from "@/pages/SettingsPage";
import LoginPage from "@/pages/LoginPage";
import CalendarPage from "@/pages/CalendarPage";
import InboxPage from "@/pages/InboxPage";
import HelpCenterPage from "@/pages/HelpCenterPage";
import BookingPage from "@/pages/BookingPage";
import UsersPage from "@/pages/UsersPage";
import SimulationPage from "@/pages/SimulationPage";
import NotFoundPage from "@/pages/NotFoundPage";
import ProtectedRoute from "@/components/ProtectedRoute";
import { ThemeProvider } from "@/context/ThemeContext";
import { SettingsProvider } from "@/context/SettingsContext";
import { AuthProvider } from "@/context/AuthContext";

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <SettingsProvider>
          <div className="App min-h-screen bg-background text-foreground">
            <BrowserRouter>
              <Routes>
                <Route path="/login" element={<LoginPage />} />
                {/* Public booking page — no auth required */}
                <Route path="/booking/:token" element={<BookingPage />} />
                <Route
                  path="/simulation"
                  element={
                    <ProtectedRoute>
                      <SimulationPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/utilisateurs"
                  element={
                    <ProtectedRoute>
                      <UsersPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/"
                  element={
                    <ProtectedRoute>
                      <Dashboard />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/leads"
                  element={
                    <ProtectedRoute>
                      <LeadsListPage />
                    </ProtectedRoute>
                  }
                />
                {/* /leads/new must come BEFORE /leads/:id so React Router
                    matches the literal first instead of capturing "new" as
                    an :id (which would 404 in LeadDetailPage). */}
                <Route
                  path="/leads/new"
                  element={<Navigate to="/leads?new=1" replace />}
                />
                <Route
                  path="/leads/:id"
                  element={
                    <ProtectedRoute>
                      <LeadDetailPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/messages"
                  element={
                    <ProtectedRoute>
                      <InboxPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/calendrier"
                  element={
                    <ProtectedRoute>
                      <CalendarPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/rapports"
                  element={
                    <ProtectedRoute>
                      <Reports />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/parametres"
                  element={
                    <ProtectedRoute>
                      <SettingsPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/aide"
                  element={
                    <ProtectedRoute>
                      <HelpCenterPage />
                    </ProtectedRoute>
                  }
                />
                {/* 404 catch-all — last route */}
                <Route
                  path="*"
                  element={
                    <ProtectedRoute>
                      <NotFoundPage />
                    </ProtectedRoute>
                  }
                />
              </Routes>
            </BrowserRouter>
            <Toaster
              position="top-right"
              richColors
              closeButton
              // Sonner's default `duration` for richColors errors is sometimes
              // missing, leaving toasts stuck on screen forever. Pin both
              // generic and per-type durations so every toast self-dismisses.
              duration={4000}
              toastOptions={{
                duration: 4000,
                classNames: { closeButton: "cursor-pointer" },
              }}
              visibleToasts={4}
            />
          </div>
        </SettingsProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
